module.exports = __webpack_public_path__ + "img/fa-light-300.a9d96b03.svg";